module.exports = __webpack_public_path__ + "img/01.ca5cae29.png";